import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-component",
  "use": "icon-component-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-component\"><defs><style type=\"text/css\"></style></defs><path d=\"M192 329.92L507.392 512v364.16V512l315.392-182.08-315.392-182.144L192 329.92zM507.392 0l443.392 256v512l-443.392 256L64 768V256l443.392-256z\" p-id=\"6298\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol